import React from "react";

import { ClientListDto } from "services/clients/restModels";

import { formatDateTime } from "shared/lib/dateTime";
import { DataTable, DataTableColumn, Pagination } from "shared/ui";

interface ClientsTableProps {
    clients: ClientListDto[];
    total: number;
    page: number;
    pageSize: number;
    onPageChange: (page: number) => void;
}

const columns: DataTableColumn<ClientListDto>[] = [
    {
        key: "id",
        title: "Клиент",
        role: "primary",
        render: (client) => `№ ${client.id}`,
    },
    {
        key: "lastOrderAt",
        title: "Последний заказ",
        role: "secondary",
        width: 200,
        render: (client) => formatDateTime(client.lastOrderAt),
    },
    {
        key: "totalOrders",
        title: "Заказов",
        role: "secondary",
        width: 100,
        align: "right",
        render: (client) => client.totalOrders,
    },
];

export const ClientsTable = ({
    clients,
    total,
    page,
    pageSize,
    onPageChange,
}: ClientsTableProps) => (
    <DataTable
        columns={columns}
        rows={clients}
        rowKey={(client) => client.id}
        footer={
            <Pagination
                page={page}
                pageSize={pageSize}
                total={total}
                onChange={onPageChange}
            />
        }
    />
);
